module.exports = __webpack_public_path__ + "img/IMG_1962_P_Black_MockedUp.7983e30a.jpg";